import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoggedIn: false,
  username: null,
  user: null, // Aquí almacenaremos toda la información del usuario
  twoFactorEnabled: false,
};

const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    iniciarSesion: (state, action) => {
      const { 
        username, 
        twoFactorEnabled, 
        nombre, 
        apellido, 
        roles, 
        email, 
        id,
        token,
        admin,
        areas,
        ...otrosDatos 
      } = action.payload;

      state.isLoggedIn = true;
      state.username = username;
      state.twoFactorEnabled = twoFactorEnabled || false;
      
      // Guardar toda la información del usuario
      state.user = {
        id,
        username,
        email,
        nombre,
        apellido,
        nombreCompleto: `${nombre} ${apellido}`,
        roles: roles || [],
        rol: roles && roles.length > 0 ? roles[0] : (admin ? 'Admin' : 'Usuario'),
        admin: admin || false,
        areas: areas || [],
        token,
        ...otrosDatos
      };

      // Guardar en localStorage toda la información necesaria
      const userToStore = {
        username,
        twoFactorEnabled: twoFactorEnabled || false,
        user: state.user
      };
      localStorage.setItem('user', JSON.stringify(userToStore));
    },

    salirSesion: (state) => {
      state.isLoggedIn = false;
      state.username = null;
      state.user = null;
      state.twoFactorEnabled = false;
      // Eliminar de localStorage
      localStorage.removeItem('user');
    },

    cargarSesion: (state) => {
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
        try {
          const parsedData = JSON.parse(storedUser);
          state.isLoggedIn = true;
          state.username = parsedData.username;
          state.twoFactorEnabled = parsedData.twoFactorEnabled || false;
          state.user = parsedData.user || null;
        } catch (error) {
          console.error('Error al cargar sesión:', error);
          // Limpiar localStorage si hay error
          localStorage.removeItem('user');
        }
      }
    },

    updateTwoFactorEnabled: (state, action) => {
      const { twoFactorEnabled } = action.payload;
      state.twoFactorEnabled = twoFactorEnabled;

      // Actualizar en localStorage
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
        try {
          console.log('vamos a cambiar el localStorage');
          const parsedUser = JSON.parse(storedUser);
          parsedUser.twoFactorEnabled = twoFactorEnabled;
          
          // También actualizar en user si existe
          if (parsedUser.user) {
            parsedUser.user.twoFactorEnabled = twoFactorEnabled;
          }
          
          localStorage.setItem('user', JSON.stringify(parsedUser));
        } catch (error) {
          console.error("Error al actualizar el 'user' en localStorage:", error);
        }
      } else {
        console.warn("No se encontró ningún usuario en localStorage.");
      }
    },

    // Acción adicional para actualizar información del usuario
    actualizarUsuario: (state, action) => {
      if (state.user) {
        state.user = { ...state.user, ...action.payload };
        
        // Actualizar localStorage
        const storedUser = localStorage.getItem('user');
        if (storedUser) {
          try {
            const parsedUser = JSON.parse(storedUser);
            parsedUser.user = state.user;
            localStorage.setItem('user', JSON.stringify(parsedUser));
          } catch (error) {
            console.error("Error al actualizar información del usuario:", error);
          }
        }
      }
    }
  },
});

export const { 
  iniciarSesion, 
  salirSesion, 
  cargarSesion, 
  updateTwoFactorEnabled, 
  actualizarUsuario 
} = sessionSlice.actions;

export default sessionSlice.reducer;